// extracted by mini-css-extract-plugin
export default {"dragAndDropQuestionContainer":"dragAndDropQuestionContainer__szrlD","buttonRow":"buttonRow__WgGku"};